import { useParticipantUnreadMessages } from '@app/api';

export const useParticipantUnreadMessageByParticipation = (
  participantId?: string,
  participationId?: string,
): number => {
  const { data: messages } = useParticipantUnreadMessages(participantId);
  if (!participantId || !participationId) {
    return -1;
  }
  return messages
    ? messages.filter((message) => message.participationId === participationId)
        .length
    : -1;
};
